import Highlight from 'components/common/Highlight';
import { LinkButton } from 'components/inputs/LinkButton';
import { useFormik } from 'formik';
import { Box, Button, FormField, TextInput } from 'grommet';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import BounceLoader from 'react-spinners/BounceLoader';
import { dispatchAction } from 'rxbeach';
import { subscribeToAction } from 'streams/subscribeToAction';
import { State } from 'types';
import { object, ref, string } from 'yup';
import { authSuccess, register } from '../stream/actions';

const validationSchema = object({
  email: string().email().required('Email er nødvendig'),
  name: string().required('Navn er også påkrevd'),
  password: string().min(5).required('Sikkeret er viktig'),
  password2: string()
    .required('🙀')
    .oneOf([ref('password')], 'Passordene må matche'),
  code: string().required(),
});

interface RegisterProps {
  state?: State;
}

const Register = ({ state }: RegisterProps) => {
  const navigate = useNavigate();
  const { touched, values, errors, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: {
        email: '',
        name: '',
        password: '',
        password2: '',
        code: '',
      },
      validationSchema,
      onSubmit: ({ email, name, password, code }) => {
        dispatchAction(register({ email, name, password, code }));
      },
    });

  useEffect(() => {
    subscribeToAction(authSuccess, () => {
      navigate('/');
    });
  }, []);

  const loading = state === State.LOADING;

  return (
    <Box fill align="center" justify="center" pad="large">
      <Box width="medium">
        <FormField label="Email" error={touched.email && errors.email} required>
          <TextInput
            id="email"
            type="text"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormField>

        <FormField label="Navn" error={touched.name && errors.name} required>
          <TextInput
            id="name"
            type="text"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormField>

        <FormField
          label="Passord"
          error={touched.password && errors.password}
          required
        >
          <TextInput
            id="password"
            type="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormField>

        <FormField
          label="Bekreft Passord"
          error={touched.password2 && errors.password2}
          required
        >
          <TextInput
            id="password2"
            type="password"
            value={values.password2}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormField>

        <FormField label="Kode" error={touched.code && errors.code} required>
          <TextInput
            id="code"
            type="text"
            value={values.code}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </FormField>

        {state === State.ERROR && (
          <Highlight
            danger
            message="Beklager, noe gikk feil. Se over at verdiene er riktig"
          />
        )}

        <Box gap="small" margin={{ top: 'medium' }}>
          <Button
            label="Opprett Bruker"
            disabled={loading}
            primary
            onClick={() => handleSubmit()}
          />
          <LinkButton disabled={loading} to="/login">
            Logg Inn
          </LinkButton>
          {loading && <BounceLoader size={40} color="#7D4CDB" loading={true} />}
        </Box>
      </Box>
    </Box>
  );
};

export default Register;
